import { createRef } from "react";
import { useEffect, useState } from "@discovery/common-dplus/lib/hooks";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import * as styles from "./styles.css";
import * as M from "@discovery/prelude/lib/data/maybe";
import { cn } from "@discovery/classnames";
import { pushModuleLinkTracking } from "@discovery/common-dplus/lib/adobe";
import { Taxonomy, TaxonomyTemplate } from "../../molecules/taxonomy";
import { Typography, HeaderVariants, Tags } from "../../atoms/typography";
import CategoryCarousel from "../../molecules/rail/_carousel-components/category-carousel";
const taxonomyContainer = createRef();
const taxonomyWeb = createRef();
const category = createRef();
const taxonomies = createRef();
let prevScrollpos = 0;
const TaxonomyItems = ({ taxonomyItemsList, template, taxonomyItemsListHero, srollToTop, onItemClick, }) => {
    const [selectedTaxonomy, setSelectedTaxonomy] = useState(0);
    const [hideTaxonomyImage, setHideTaxonomyImage] = useState(false);
    const onscroll = () => {
        const taxonomyCont = taxonomyContainer.current;
        const categoryTaxo = category.current;
        const navbar = document.getElementById("#navbar");
        const currentScrollPos = window.pageYOffset;
        const navbarHeight = navbar.offsetHeight;
        if (taxonomyCont)
            taxonomyCont.style.zIndex = "1005";
        if (currentScrollPos <= navbarHeight) {
            if (taxonomyCont)
                taxonomyCont.style.top = "0px";
            setHideTaxonomyImage(false);
            if (categoryTaxo)
                categoryTaxo.style.top = "90px";
        }
        else if (prevScrollpos > currentScrollPos) {
            if (categoryTaxo)
                categoryTaxo.style.top = `90px`;
            if (taxonomyCont)
                taxonomyCont.style.transition = "top 0.3s";
        }
        else {
            setHideTaxonomyImage(true);
            if (taxonomyCont)
                taxonomyCont.style.top = "50px";
        }
        prevScrollpos = currentScrollPos;
    };
    const sendAnalyticsEvents = (item, index) => {
        const indexValue = index + 1;
        const itemPosition = indexValue.toString();
        item.urlM &&
            pushModuleLinkTracking(config.standardPageRouteFragments.home, itemPosition, item.name, "genre", "www.discoveryplus.in/home", M.fromMaybe(item.urlM, ""));
    };
    useEffect(() => {
        const taxonomyCont = taxonomyContainer.current;
        const taxonomyCategory = category.current;
        taxonomyCont || taxonomyCategory
            ? window.addEventListener("scroll", onscroll)
            : null;
        return () => window.removeEventListener("resize", onscroll);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const taxonomyItemHandler = (index, item) => {
        const id = item && item.id;
        const name = item && item.name;
        const navbarScroll = taxonomies.current;
        if (navbarScroll)
            navbarScroll.scrollLeft = index * 86;
        setSelectedTaxonomy(index);
        srollToTop && srollToTop();
        onItemClick && onItemClick(id, name);
    };
    const renderDesktopTaxonomyList = () => {
        return (React.createElement("div", { className: styles.listcontainer, ref: category }, taxonomyItemsList && taxonomyItemsList.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.categoryContainer },
                React.createElement(Typography, { classNameM: M.of(styles.title), variant: HeaderVariants.subHeadTwo, tag: Tags.span },
                    React.createElement(React.Fragment, null, "Categories wise"))),
            React.createElement("div", { className: styles.separatorWrapper },
                React.createElement("div", { className: styles.separator })),
            taxonomyItemsList.map((item, index) => {
                return (React.createElement("div", { key: index },
                    React.createElement("div", { className: styles.box, onClick: () => {
                            taxonomyItemHandler(index, item);
                        }, id: `#category` },
                        React.createElement(Typography, { classNameM: M.of(selectedTaxonomy === index
                                ? styles.selectedHeader
                                : styles.header), variant: HeaderVariants.subHeadTwo, tag: Tags.span },
                            React.createElement(React.Fragment, null, item.name))),
                    index <= taxonomyItemsList.length - 2 && (React.createElement("div", { className: styles.separatorWrapper },
                        React.createElement("div", { className: selectedTaxonomy === index
                                ? styles.selectedSeparator
                                : styles.separator })))));
            })))));
    };
    return (React.createElement(React.Fragment, null, template === TaxonomyTemplate.HERO ? (window.innerWidth <= 699 ? (React.createElement("div", { className: styles.heroContainer },
        React.createElement("div", { className: styles.wrapperM }, taxonomyItemsListHero &&
            taxonomyItemsListHero.map((item, index) => {
                return (React.createElement("div", { onClick: () => sendAnalyticsEvents(item, index) },
                    React.createElement(Taxonomy, { name: item.name, imgUrl: item.mobileImg && item.mobileImg.src, onClickM: M.of(() => { }), selectedTaxonomy: index, index: index, hideTaxonomyImage: false, template: template, urlM: item.urlM, key: index })));
            })))) : (React.createElement(CategoryCarousel, { taxonomyItemsListHero: taxonomyItemsListHero }))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn(styles.swiperContainer, hideTaxonomyImage
                ? styles.stickyTaxonomy
                : styles.nonStickyTaxonomy), ref: taxonomyContainer },
            React.createElement("div", { className: styles.taxonomyWeb, ref: taxonomyWeb },
                React.createElement("div", { className: styles.TaxonomyListContainer, id: "#taxonomy" },
                    React.createElement(React.Fragment, null, taxonomyItemsList &&
                        taxonomyItemsList.map((item, index) => {
                            return (React.createElement(Taxonomy, { name: item.name, srcM: item.srcM, onClickM: M.of(() => {
                                    taxonomyItemHandler(index, item);
                                }), selectedTaxonomy: selectedTaxonomy, index: index, hideTaxonomyImage: hideTaxonomyImage, template: template, urlM: M.of(""), isShorts: true, key: index }));
                        }))))),
        renderDesktopTaxonomyList()))));
};
export default TaxonomyItems;

